import { render } from "./linkify.area.vue?vue&type=template&id=8e5c3be8"
import script from "./linkify.area.vue?vue&type=script&lang=js"
export * from "./linkify.area.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__